<div class="tracking-dialog">

    <!-- HEADER -->
    <header class="tracking-header">

        <div class="tracking-header__content">

            <span class="tracking-header__eyebrow">
                NINA PASTELERÍA
            </span>

            <h2>
                Seguimiento de tu
                <span class="nina-brand-italic">pedido</span>
            </h2>

            <div class="tracking-header__status">

                <div class="tracking-status-icon">
                    <mat-icon>local_shipping</mat-icon>
                </div>

                <div class="tracking-status-info">

                    <span class="tracking-status-label">
                        Tiempo estimado
                    </span>

                    <strong>
                        {{ estimatedTime }} minutos
                    </strong>

                </div>

            </div>

        </div>

        <button type="button" class="tracking-close" mat-dialog-close aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>

    </header>


    <!-- MAPA -->
    <section class="tracking-map-wrapper">

        <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">

            <!-- REPARTIDOR -->
            <agm-marker [latitude]="dealerLatitude" [longitude]="dealerLongitude"
                *ngIf="dealerLatitude != 0 && dealerLongitude != 0" [iconUrl]="dealerIcon">

                <agm-info-window>
                    <p>Tu repartidor</p>
                </agm-info-window>

            </agm-marker>


            <!-- NINA -->
            <agm-marker [latitude]="originLatitude" [longitude]="originLongitude"
                *ngIf="originLatitude != 0 && originLongitude != 0" iconUrl="assets/img/nina_pin.png">

                <agm-info-window>
                    <p>Nina Pastelería</p>
                </agm-info-window>

            </agm-marker>


            <!-- DESTINO -->
            <agm-marker [latitude]="destinyLatitude" [longitude]="destinyLongitude"
                *ngIf="destinyLatitude != 0 && destinyLongitude != 0" iconUrl="assets/img/destiny_pin.png">

                <agm-info-window>
                    <p>Tu punto de entrega</p>
                </agm-info-window>

            </agm-marker>

        </agm-map>


        <!-- TARJETA SOBRE EL MAPA -->
        <div class="tracking-map-card">

            <div class="tracking-map-card__item">

                <div class="tracking-map-card__icon tracking-map-card__icon--origin">
                    <mat-icon>storefront</mat-icon>
                </div>

                <div>
                    <span>Origen</span>
                    <strong>Nina Pastelería</strong>
                </div>

            </div>


            <div class="tracking-map-card__line"></div>


            <div class="tracking-map-card__item">

                <div class="tracking-map-card__icon tracking-map-card__icon--delivery">
                    <mat-icon>location_on</mat-icon>
                </div>

                <div>
                    <span>Destino</span>
                    <strong>Tu punto de entrega</strong>
                </div>

            </div>

        </div>


        <!-- INDICADOR DEL REPARTIDOR -->
        <div class="tracking-driver" *ngIf="dealerLatitude != 0 && dealerLongitude != 0">

            <span class="tracking-driver__pulse"></span>

            <div>
                <span>Tu repartidor</span>
                <strong>En movimiento</strong>
            </div>

        </div>

    </section>

</div>